"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.object.freeze");
var _ActivityPopup = _interopRequireDefault(require("./components/ActivityPopup.vue"));
var _ItemActivity = _interopRequireDefault(require("./components/ItemActivity"));
var _activityCreationApi = require("@/api/activityCreationApi");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Index',
  components: {
    ItemActivity: _ItemActivity.default,
    ActivityPopup: _ActivityPopup.default
  },
  data: function data() {
    return {
      tableLoading: false,
      platformList: Object.freeze([{
        name: '淘宝',
        type: 'TB'
      }, {
        name: '京东',
        type: 'JD'
      }, {
        name: '淘宝闪购',
        type: 'ELM'
      }, {
        name: '抖音',
        type: 'DY'
      }, {
        name: '拼多多',
        type: 'PDD'
      }, {
        name: '唯品会',
        type: 'WPH'
      }, {
        name: '美团',
        type: 'MT'
      }]),
      options: [{
        value: '0',
        label: '未开始'
      }, {
        value: '1',
        label: '进行中 '
      }, {
        value: '2',
        label: '已结束'
      }],
      listActivityData: [],
      delDialogVisible: false,
      // 删除弹窗
      pagination: {
        currentPage: 1,
        // 默认第几页
        total: 0 // 条数
      },
      queryData: {
        unionCode: '',
        // unionCode
        jumpType: 2,
        status: '',
        name: '',
        page: {
          page: 1,
          size: 10
        }
      }
    };
  },
  created: function created() {
    this.listActivityApi();
  },
  methods: {
    search: function search() {
      this.queryData.page.page = 1;
      this.listActivityApi();
    },
    rest: function rest() {
      this.queryData.page.page = 1;
      this.queryData.unionCode = '';
      this.queryData.status = '';
      this.queryData.name = '';
      this.listActivityApi();
    },
    // 选择平台
    onPlatform: function onPlatform(type) {
      this.queryData.unionCode = type;
      this.listActivityApi();
    },
    // 新增
    onAddEvents: function onAddEvents() {
      this.$refs.activityPopup.open('add');
    },
    // 事件传递
    controls: function controls(val) {
      var _this = this;
      if (val.type === 'editor') {
        this.$refs.activityPopup.open('editor', val.id);
      } else if (val.type === 'delete') {
        // this.delDialogVisible = true
        this.$confirm('是否确认要删除该活动?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          _this.deleteActivityApi(Number(val.id));
        }).catch(function () {
          _this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      }
    },
    // 删除
    onVerify: function onVerify() {
      this.delDialogVisible = false;
      // this.$confirm('确认删除？')
      //   .then(_ => {
      //     console.log('确认删除？')
      //     this.delDialogVisible = false
      //   })
      //   .catch(_ => {})
    },
    // 分页
    handleSizeChange: function handleSizeChange(val) {
      console.log("\u6BCF\u9875 ".concat(val, " \u6761"));
      this.queryData.page.size = val;
      this.listActivityApi();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      console.log("\u5F53\u524D\u9875: ".concat(val));
      this.queryData.page.page = val;
      this.listActivityApi();
    },
    onRefresh: function onRefresh() {
      console.log('刷新页面');
      this.listActivityApi();
    },
    // 列表
    listActivityApi: function () {
      var _listActivityApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              this.tableLoading = true;
              params = (0, _objectSpread2.default)({}, this.queryData);
              _context.n = 1;
              return (0, _activityCreationApi.listActivityApi)(params);
            case 1:
              res = _context.v;
              this.tableLoading = false;
              if (res.code === 0) {
                this.listActivityData = res.data.records;
                this.pagination.total = res.data.total;
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function listActivityApi() {
        return _listActivityApi2.apply(this, arguments);
      }
      return listActivityApi;
    }(),
    // 删除活动
    deleteActivityApi: function () {
      var _deleteActivityApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(id) {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = {
                // userId:'',
                // activityId
                id: id
              };
              _context2.n = 1;
              return (0, _activityCreationApi.deleteActivityApi)(params);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                this.listActivityApi();
                this.$notify.success({
                  title: '温馨提示',
                  message: '删除成功'
                });
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function deleteActivityApi(_x) {
        return _deleteActivityApi2.apply(this, arguments);
      }
      return deleteActivityApi;
    }()
  }
};